import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { RootScopeService } from '../../../services/root-scope.service';
import { DOMAIN_LABEL_KEY, ERRMSG_VIEWJSONDATA } from '../../../models/Constants';

@Component({
  selector: 'app-view-json',
  templateUrl: './view-json.component.html',
  styleUrls: ['./view-json.component.scss']
})
export class ViewJsonComponent implements OnInit {

  viewUDPJSONDataMap = new Map<string, any[]>();
  apiFailureMsg = ERRMSG_VIEWJSONDATA;

  /** CCR1-10309 */
  constructor(public apiService: ApiService,
    public rootScope: RootScopeService
  ) { 

    this.getViewJSONData();
  }
 


  getViewJSONData(){

    if(this.rootScope.activeCustTab.viewJsonData.viewUDPJSONDataMap?.size > 0){
      return;
    }

    
    this.apiService.getViewJsonData().subscribe({
      next: (data:any) => {
        console.log('View JSON Data:', data);
        this.parseModifyViewJSONData(data?.data?.domainResponses);
        this.rootScope.activeCustTab.viewJsonData.apiFailed = false;  
      },
      error: (error: any) => {
        console.error('Error fetching JSON data:', error);
        this.rootScope.activeCustTab.viewJsonData.apiFailed = true
      },
    })
 }

  ngOnInit(): void {
     
  }

  parseModifyViewJSONData(data:any){
    this.rootScope.activeCustTab.viewJsonData.viewUDPJSONDataMap = new Map<string, any[]>();
    data?.forEach((item:any) =>{
      this.rootScope.activeCustTab.viewJsonData.viewUDPJSONDataMap.set(item?.[DOMAIN_LABEL_KEY], item.providers);
      this.rootScope.activeCustTab.viewJsonData.apiNameList.push(item?.[DOMAIN_LABEL_KEY]);
    });  
    this.rootScope.activeCustTab.viewJsonData.selectedAPIName = data?.[0]?.[DOMAIN_LABEL_KEY];
 }

 getSelectedAPIData()  {
   if(this.rootScope.activeCustTab.viewJsonData.viewUDPJSONDataMap.size && this.rootScope.activeCustTab.viewJsonData.viewUDPJSONDataMap.size != 0)
       return this.rootScope.activeCustTab.viewJsonData.viewUDPJSONDataMap?.get(this.rootScope.activeCustTab.viewJsonData.selectedAPIName);
 }

  onAPINameClick(apiName: any) {
   this.rootScope.activeCustTab.viewJsonData.selectedAPIName = apiName
  }

}
